import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import FilmsPage from "@/pages/FilmsPage";
import DonatePage from "@/pages/DonatePage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-[#FAF9F6]">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/films" element={<FilmsPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/contact-us" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#FFFFFF',
              border: '1px solid rgba(41, 37, 36, 0.1)',
              color: '#292524',
              fontFamily: "'DM Sans', sans-serif",
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
